import { useContext, useCallback, useState, useEffect } from "react";
import NumbersContext                                   from "../contexts/NumbersContext";
import { usePusher }                                    from "@harelpls/use-pusher";
import { isDevelopment }                                from "../constants/app";

export default function useNumbersSubscription(event, handler) {
  const { numbers } = useContext(NumbersContext);
  const { client } = usePusher();
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    const subs = [];
    numbers.forEach((num) => {
      if(!client) return;
      let channel = client.subscribe(`private-number-${num.id}`);
      if (isDevelopment) {
        console.log("Subscribed to number channel", `private-number-${num.id}`);
      }
      subs.push(channel);
    });
    setChannels(subs);
    return () => {
      channels.forEach((c) => {
        client.unsubscribe(c.name);
        if (isDevelopment) {
          console.log("Unsubscribed from number channel", c.name);
        }
      });
      setChannels([]);
    };
  }, [numbers]);

  useEffect(() => {
    channels.map((c) => {
      c.bind(event, handler);
      if (isDevelopment && c){
        console.log(`Started listening for ${event} on ${c.name} channel`);
      }
    });
    return () => {
      channels.map((c) => {
        c.unbind(event, handler);
        if (isDevelopment && c){
          console.log(`Stopped listening for ${event} on ${c.name} channels`);
        }
      });
    };
  }, [channels, event, handler]);

  return [channels, client?.connection?.socket_id];
}
